import { AxiosInstance } from 'axios'
import moment from 'moment'
import { IJsonApiSerializer } from '../JsonApiSerializer'

class UtilService {
  public httpClient: AxiosInstance
  public serializer: IJsonApiSerializer

  constructor(httpClient: AxiosInstance, serializer: IJsonApiSerializer) {
    this.httpClient = httpClient
    this.serializer = serializer
  }

  public getDataFromJson(resource) {
    const data = this.serializer.parseResourceData(resource, resource.data)

    return { data }
  }

  public formatPriceForForm: (price: string | number) => string = price => {
    return typeof price === 'number' ? price.toString() : price.replace(',', '')
  }

  public separate = (stringNum: string) => {
    const len = stringNum.length

    if (len > 3) {
      return this.separate(stringNum.substring(0, len - 3)) + ',' + stringNum.substring(len - 3)
    } else {
      return stringNum
    }
  }

  public formatPrice = (price: number | null) => {
    if (price === null || price === undefined) {
      return ''
    }
    return `¥${this.separate(String(price))}`
  }

  public formatPriceToNumber = (price: string | number) => {
    return typeof price === 'string' ? parseInt(price.replace(/,/g, ''), 10) : price
  }

  public formatPriceOnlyYen = (price: number) => {
    return `¥${String(price)}`
  }

  public formatDateFromLocale = (date: string, locale: string, format: string) => {
    if (locale === 'ja') {
      return moment(date, 'YYYYMMDD').format(format)
    }
    return moment(date).format(format)
  }

  /**
   * 入力された xx:xx の時間に AM/PM を付与する
   * 例: 08:00 -> 8:00 AM, 13:00 -> 1:00 PM
   * @param time
   * @returns
   */
  public formatWithAmPm = (time: string) => {
    const hour = parseInt(time.split(':')[0], 10)
    const minute = time.split(':')[1]
    const ampm = hour < 12 ? 'AM' : 'PM'
    const hour12 = hour % 12 || 12
    return `${hour12}:${minute} ${ampm}`
  }

  /**
   * 4桁のIDを返す
   * 例: 1 -> '0001', 12 -> '0012',
   * @param id
   * @returns
   */
  public getId4digit = (id: number) => {
    if (isNaN(id) || id < 0) {
      throw new Error('IDが数値ではないか、0以下です')
    }
    return id.toString().padStart(4, '0')
  }
}

export default UtilService
